// @ts-nocheck
import { Overlay } from '@angular/cdk/overlay';
import { Component, EventEmitter, HostBinding, Input, OnInit, Output, inject } from '@angular/core';
import { IconComponent } from '@lbca-shared/icon';
import { MessageFeedTemplate } from 'models/shared.models';
import moment from 'moment';
import { ASSETS } from '../../../../../../assets/assets';
import { MessageFeedbackComponent } from '../../../../message-feedback/message-feedback.component';
import {
  PopupFeedbackDirective,
  PopupInterfaceCommunication,
} from '../../../../popup-feedback/popup-feedback.directive';
import { TableSecondaryComponent } from '../../../../table-secondary/table-secondary.component';
import { fieldList } from '../claim.fields';
import { ClaimService } from '../claim.service';

@Component({
  selector: 'lbca-claim-edit-legal-request',
  templateUrl: './claim-edit-legal-request.component.html',
  styleUrl: '../../sub-form/subform.component.scss',
  imports: [MessageFeedbackComponent, TableSecondaryComponent, IconComponent],
})
export class ClaimEditLegalRequestComponent implements OnInit {
  readonly assets = inject(ASSETS);
  @Input() taskId;
  @Input() pedidoEdit;
  @Input() editPhase;
  @Input() currentLegalRequest;
  @Input() disabled: boolean = true;

  public cardInfo: any;
  @Input()
  set cardData(data: any) {
    this.cardInfo = data;
  }

  public loadPage: boolean = false;

  @Output('realoadDataOutput') realoadDataEmmitter = new EventEmitter();
  @Output('closeModalOutput') closeModalEmmitter = new EventEmitter();

  private popupFeedController = new PopupInterfaceCommunication();
  @HostBinding('attr.lbcaPopupFeedback') popupFeedback = new PopupFeedbackDirective(
    this.overlay,
    this.popupFeedController
  );

  public tableEdit: any = [];

  public claimLabelsDict: Object | any = {};

  private fieldList = fieldList;

  public submitButtonEditClaim: boolean = false;

  public messageFeedObject: MessageFeedTemplate = {
    primary: '',
    secondary: '',
    emoji: '',
    type: 'danger',
    show: false,
    autoclose: true,
  };

  public closeFeed(): void {
    this.messageFeedObject.show = false;
  }

  public msgEditClaim: string = '';

  constructor(private claimService: ClaimService, private overlay: Overlay) {}

  ngOnInit(): void {
    this.claimLabelsDict = this.assets.labels.components.claim;
    this.msgEditClaim = this.claimLabelsDict['editClaim'].split('|');
    setTimeout(() => this.constructModalEditTable(), 100);
  }

  public async changeValueEdit($event) {
    const pedido = $event.lane;
    const obj = $event.montaObj;

    if (!obj && !pedido) {
      this.pedidoEdit[0][$event.entityKey] = $event.value;
    } else {
      this.pedidoEdit = [pedido];
      this.pedidoEdit[0][obj.entityKey] = obj.value;
      if (obj.hasOwnProperty('enabled') && obj.enabled === false) {
        obj?.fields.forEach((item) =>
          item.forEach((field) => (this.pedidoEdit[0][field.entityKey] = null))
        );
      }

      if (
        obj.entityKey === 'primaryValue' ||
        obj.entityKey === 'primaryIndexId' ||
        obj.entityKey === 'dateReference'
      ) {
        const respPromise: any = await this.claimService.calcValoresCadastroPedidos(pedido);
        this.pedidoEdit[0]['riskCalculate'] = respPromise.valTotalRisco;
      }
    }
  }

  public editLegalRequest($event) {
    // edição de pedidos
    const taskId = this.taskId;
    this.submitButtonEditClaim = true;
    const pedidos = JSON.parse(JSON.stringify(this.pedidoEdit));

    pedidos.forEach((item: any) => {
      item.primaryValue = item.primaryValue ? parseFloat(item.primaryValue).toFixed(2) : null;
      item.riskCalculate = item.riskCalculate ? parseFloat(item.riskCalculate).toFixed(2) : null;
    });

    const body = pedidos[0];

    if (body.user) delete body.user;

    const bodyCopy = JSON.parse(JSON.stringify(pedidos))[0];
    this.mountLocalRequests(bodyCopy);

    const params = { id: body.id, taskId };

    this.claimService.editClaim(body, params).subscribe(
      (resp: any) => {
        if (resp.errors) {
          this.submitButtonEditClaim = false;
          this.defautlFeedbackServerError(resp.errors);
          return;
        }

        this.realoadDataEmmitter.emit(true); // CRIAR O EMMITER
        this.closeModal();
        this.submitButtonEditClaim = false;
      },
      (err: any) => {
        this.submitButtonEditClaim = false;
        this.defautlFeedbackServerError(err);
      }
    );
  }

  closeModal() {
    this.closeModalEmmitter.emit(true);
  }

  private constructModalEditTable() {
    this.tableEdit = [];
    const colsEdit: any[] = [];
    const colsEditSec: any[] = [];

    const fieldListEdit = fieldList;

    fieldListEdit.primary.forEach((element, index) => {
      const obj: any = {
        name: element.entityKey,
        label: element.label,
        type: 'data',
        orderDefault: index === 1 ? true : false,
        order: false,
        col: element.size,
        field: element,
      };
      //ta com BO aqui
      if (element.entityKey) {
        colsEdit.push(obj);
      }
    });

    colsEdit.push({
      name: 'details',
      label: '',
      type: 'details-table',
      col: 1,
    });

    let obj = {};
    const col = 0;
    fieldListEdit.secondary.forEach((element, index) => {
      if (element.type === 'ADDITIONAL_VALUES') {
        element.fields.forEach((item) => {
          if (item.fields.length) {
            item.fields.forEach((subItems) => {
              if (subItems.length) {
                subItems.forEach((subsubItems) => {
                  obj = {
                    name: subsubItems.entityKey,
                    label: subsubItems.label,
                    type: 'data',
                    orderDefault: index === 1 ? true : false,
                    order: false,
                    col: subsubItems.size,
                    field: subsubItems,
                  };
                  colsEditSec.push(obj);
                });
              } else {
                obj = {
                  name: subItems.entityKey,
                  label: subItems.label,
                  type: 'data',
                  orderDefault: index === 1 ? true : false,
                  order: false,
                  col: subItems.size,
                  field: subItems,
                };
                colsEditSec.push(obj);
              }
            });
          } else {
            obj = {
              name: item.entityKey,
              label: item.label,
              type: 'data',
              orderDefault: index === 1 ? true : false,
              order: false,
              col: item.size,
              field: item,
            };
            colsEditSec.push(obj);
          }
        });
      } else {
        obj = {
          name: element.entityKey,
          label: element.label,
          type: 'data',
          orderDefault: index === 1 ? true : false,
          order: false,
          col: element.size,
          field: element,
        };
        colsEditSec.push(obj);
      }
    });

    this.tableEdit = {
      config: {
        highlight: () => {
          return true;
        },
      },
      columns: colsEdit,
      details: colsEditSec,
      body: this.pedidoEdit,
    };

    this.loadPage = true;
  }

  private mountLocalRequests(item: any): void {
    item.dateReference = this.dateTreatment(item.dateReference);
    item.interestDateReference = this.dateTreatment(item.interestDateReference);
    item.primaryValue = parseFloat(item.primaryValue || 0).toFixed(2);
    item.riskCalculate = parseFloat(item.riskCalculate || 0).toFixed(2);
  }

  private defautlFeedbackServerError(error): boolean {
    this.setFeedback(
      this.claimLabelsDict['error-server-primary'],
      this.claimLabelsDict['error-server-secondary'],
      'emoji--expressionless',
      'danger'
    );
    return false;
  }

  private setFeedback(
    primary: string,
    secondary: string,
    emoji: string,
    type: 'danger' | 'warning' | 'success',
    autoclose = true
  ): void {
    this.messageFeedObject.primary = primary;
    this.messageFeedObject.secondary = secondary;
    this.messageFeedObject.emoji = emoji;
    this.messageFeedObject.type = type;
    this.messageFeedObject.autoclose = autoclose;
    this.messageFeedObject.show = true;
  }

  private dateTreatment(unixValue) {
    if (unixValue) return moment.unix(unixValue).format(moment.defaultFormat);
    else return null;
  }
}
